import input from './input.vue'
input.install = function (Vue) {
  Vue.component(input.name, input);
};
export default input



// WEBPACK FOOTER //
// ./src/ni-ui/input/index.js